import { get } from 'lodash';

/**
 * @return {Promise<Array>}
 */
export async function getStreamAccessDefinitions() {
    const response = await this.get('v1/svp/{PROVIDER}/assets/accessDefinitions');
    return get(response, '_embedded.accessDefinitions', []);
}
